<template>
  <el-table
    v-if="filteredRows.length > 0"
    :data="filteredRows"
    border
    style="width: 100%"
  >
    <el-table-column prop="name" label="Name" />
    <el-table-column prop="_id" label="_id" />
  </el-table>
</template>

<script>
export default {
  props: {
    instrumentList: {
      type: Array,
      required: true,
    },
    project: {
      required: true,
    },
  },
  data(){
    return {
      disabledInstrumentList: [],
    };
  },
  computed: {
    filteredRows() {
      const instruments = {};
      this.instrumentList.forEach(ins => {
        instruments[ins._id] = ins;
      });
      return this.disabledInstrumentList.filter(ins => {
        return instruments[ins._id];
      });
    },
  },
  mounted(){
    this.getDisabledInstrumentList();
  },
  methods: {
    async getDisabledInstrumentList(){
      const res = await this.$axios({
        category: 'project',
        method: 'get',
        apiName: `${this.project}/instrument/disabled`,
      });
      console.log(res.data);
      console.log(this.instrumentList);
      this.disabledInstrumentList = res.data.map(ele=>{
        return {
          _id: ele._id,
          name: ele.data[0].name,
        };
      });
    },
  },
};
</script>